module.exports = __webpack_public_path__ + "img/icon_sm_fxcb.6e792c34.png";